import React, { useEffect, useState } from "react";
import Loader from "./Loader.jsx";

const GlobalLoader = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleGlobalLoading = (event) => {
      const { isLoading } = event.detail || {};
      setVisible(!!isLoading);
    };

    window.addEventListener("global-loading", handleGlobalLoading);

    return () => {
      window.removeEventListener("global-loading", handleGlobalLoading);
    };
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/60">
      <Loader />
    </div>
  );
};

export default GlobalLoader;


